module.exports = __webpack_public_path__ + "img/ic_point_2.1e0619f5.svg";